import React, { useContext } from 'react';
import {
    useSamplesCatalog,
    useBundleCatalog,
    useCatalogSale,
    Languages,
} from '@landr/pricing';
import { i18n } from 'utils/setupTranslations';
import { useUserSubscriptionContext } from 'contexts/UserSubscriptionContext/UserSubscriptionContext';
import useUpsellActionsProvider from './useUpsellActionsProvider';
import { UpsellActionsProviderProps, UpsellActionsContextType } from './types';
import { defaultUpsellActionsContext } from './default';

const LocaleToLanguage: { [key: string]: Languages } = {
    en: Languages.English,
    fr: Languages.French,
};

export const UpsellActionsContext =
    React.createContext<UpsellActionsContextType>(defaultUpsellActionsContext);

export const UpsellActionsProvider = ({
    children,
    creditsNeeded,
}: UpsellActionsProviderProps): JSX.Element => {
    const { hasStudioPlan, hasSubscription } = useUserSubscriptionContext();

    const { data: catalogSale } = useCatalogSale({
        includePrismicContent: true,
        language: LocaleToLanguage[i18n.locale] ?? Languages.English,
    });
    const { data: samplesCatalog } = useSamplesCatalog();
    const { data: studioCatalog } = useBundleCatalog();

    const context = useUpsellActionsProvider({
        creditsNeeded,
        catalogSale,
        samplesCatalog,
        studioCatalog,
    });

    return (
        <UpsellActionsContext.Provider
            value={{ ...context, hasStudioPlan, hasSubscription }}
        >
            {children}
        </UpsellActionsContext.Provider>
    );
};

export const useUpsellActionsContext = (): UpsellActionsContextType =>
    useContext(UpsellActionsContext);

export default UpsellActionsProvider;
